module.exports = __webpack_public_path__ + "img/img12.442095ef.png";